module.exports = __webpack_public_path__ + "img/l-cb-yr1.f0739f09.gif";